<template>
  <div>
    <el-form ref="formRef" :model="zoneForm" label-width="120px">
      <el-form-item label="是否置顶：">
        <el-select v-model="topState" value-key="value" placeholder="请选择" size="mini" style="width: 8em;">
          <el-option v-for="item in topStateArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="置顶时间：" v-if="topState == 1 || topState == 2">
        <el-date-picker
            v-model="dateTime"
            type="datetimerange"
            :shortcuts="shortcuts"
            range-separator=" - "
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item label="置顶列表：" v-if="topState == 1 || topState == 2">
        <el-select v-model="topType" value-key="value" placeholder="请选择" size="mini" style="width: 8em;">
          <el-option v-for="item in topTypeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否推送：" v-if="topState == 1 || topState == 2">
        <el-select v-model="topPush" value-key="value" placeholder="请选择" size="mini" style="width: 8em;">
          <el-option v-for="item in topPushArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="性别列表：" v-if="topState == 1 || topState == 2">
        <el-select v-model="topSex" value-key="value" placeholder="请选择" size="mini" style="width: 8em;">
          <el-option v-for="item in topSexArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >返回</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">提交</el-button>
    </div>
  </div>
</template>

<script>
import {updateZoneTopState} from '../../../api/url'
import {postFormData, getFormData} from "@/api/api";

export default {
  name: "SetQualityDialog",
  props: {
    value: Object
  },
  data() {
    return {
      zoneForm: this.value.zoneForm,
      loading: false,

      dateTime: [this.value.zoneForm.topStartTime, this.value.zoneForm.topEndTime],

      // 是否置顶
      topStateArray: [
        {label: '置顶', value: 1},
        {label: '不置顶', value: 0},
      ],
      topState: this.value.zoneForm.topState == 1 || this.value.zoneForm.topState == 2?1:0,

      // 置顶列表
      topTypeArray: [
        {label: '全部', value: 0},
        {label: '最新', value: 1},
        {label: '热门', value: 2},
        {label: '推荐', value: 3}
      ],
      topType: this.value.zoneForm.topType?this.value.zoneForm.topType:0,

      // 是否推送
      topPushArray: [
        {label: '推送', value: 1},
        {label: '不推送', value: 0}
      ],
      topPush: this.value.zoneForm.topPush ? 1 : 0,

      // 性别列表
      topSexArray: [
        {label: '全部', value: 0},
        {label: '异性', value: 1}
      ],
      topSex: this.value.zoneForm.topSex ? 1 : 0,

      shortcuts: [
        {
          text: '最近一周',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            return [start, end]
          },
        },
        {
          text: '最近一个月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            return [start, end]
          },
        },
        {
          text: '最近三个月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            return [start, end]
          },
        },
      ]

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    submit() {
      if(this.topType == null) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请选择置顶列表',
          type: 'warning'
        })
        return;
      }
      if(this.topPush == null) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请选择是否推送',
          type: 'warning'
        })
        return;
      }
      this.loading = true
      let param = {}
      if(this.zoneForm.topId) {
        param['id'] = this.zoneForm.topId;
      }else {
        param['id'] = 0;
      }
      param['zoneId'] = this.zoneForm.id;
      param['state'] = this.topState;
      if(this.topSex == 1) {
        this.zoneForm.topSex = this.zoneForm.sex;
      } else {
        this.zoneForm.topSex = 0;
      }
      if(this.topState == 1) {
        param['startTime'] = this.dateTime[0];
        param['endTime'] = this.dateTime[1];
        param['type'] = this.topType;
        param['push'] = this.topPush;
        param['topSex'] = this.zoneForm.topSex;
      } else {
        param['startTime'] = this.zoneForm.topStartTime;
        param['endTime'] = this.zoneForm.topEndTime;
        param['type'] = 0;
        param['push'] = 0;
        param['topSex'] = 0;
      }
      postFormData(updateZoneTopState, param).then((data)=>{
        let {code, msg} = data;
        if(code == 200) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm')
        }else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },

  },
  created() {
  }
}
</script>

<style scoped>

</style>
